import {ButtonType} from 'types'

export const BUTTON_SIZE_MAP: Record<ButtonType, number> = {
  large: 56,
  normal: 42,
  small: 34,
  smallest: 28,
}
